import { useContext } from 'react';
import AppContext from '../../../AppContext';
import styles from './ReinsurersRow.module.css';
import HeaderHelmet, { HeaderHelmetProps } from '../../SubSectionHeader/HeaderHelmet';
import { SubSectionHeaderType } from '../../Section/SubSectionHeaderType';

interface ReinsurersHeaderProps {
  helmet: HeaderHelmetProps;
}

export default function ReinsurersHeader({ helmet }: ReinsurersHeaderProps) {
  const { showBenchmark, year } = useContext(AppContext);

  function getHeader(subSectionHeaderType = SubSectionHeaderType.REINSURERS) {
    if (subSectionHeaderType === SubSectionHeaderType.REINSURERS) {
      return (
        <>
          <h5 className="column_align_right">Premiums</h5>
          <h5 className="column_align_right">% of Total</h5>
          <h5 className="column_align_right">Recoverable</h5>
          <h5 className="column_align_right">% of Total</h5>
        </>
      );
    } else if (subSectionHeaderType === SubSectionHeaderType.REINSURERS_WITH_YEAR) {
      return (
        <>
          <h5 className="column_align_right">{year} Premium</h5>
          <h5 className="column_align_right">{year} % of Total</h5>
          <h5 className="column_align_right">{year - 1} Premium</h5>
          <h5 className="column_align_right">{year - 1} % of Total</h5>
        </>
      );
    } else if (subSectionHeaderType === SubSectionHeaderType.REINSURERS_RECOVERABLE_FIRST) {
      return (
        <>
          <h5 className="column_align_right">Recoverable</h5>
          <h5 className="column_align_right">% of Total</h5>
          <h5 className="column_align_right">Premiums</h5>
          <h5 className="column_align_right">% of Total</h5>
        </>
      );
    } else if (subSectionHeaderType === SubSectionHeaderType.REINSURERS_LIFE_CEDED) {
      return (
        <>
          <h5 className="column_align_right">CY Life Ceded Rsv</h5>
          <h5 className="column_align_right">CY Life Ceded MODCO Rsv</h5>
          <h5 className="column_align_right">As a % of Total</h5>
          <h5 aria-hidden="true"></h5>
        </>
      );
    } else if (subSectionHeaderType === SubSectionHeaderType.REINSURERS_LIFE_ASSUMED) {
      return (
        <>
          <h5 className="column_align_right">CY Life Assumed Rsv</h5>
          <h5 className="column_align_right">CY Life Assumed MODCO Rsv</h5>
          <h5 className="column_align_right">As a % of Total</h5>
          <h5 aria-hidden="true"></h5>
        </>
      );
    } else if (subSectionHeaderType === SubSectionHeaderType.REINSURERS_AH_CEDED) {
      return (
        <>
          <h5 className="column_align_right">CY A&H Ceded Prem</h5>
          <h5 aria-hidden="true"></h5>
          <h5 className="column_align_right">As a % of Total</h5>
          <h5 aria-hidden="true"></h5>
        </>
      );
    } else if (subSectionHeaderType === SubSectionHeaderType.REINSURERS_AH_ASSUMED) {
      return (
        <>
          <h5 className="column_align_right">CY A&H Assumed Prem</h5>
          <h5 aria-hidden="true"></h5>
          <h5 className="column_align_right">As a % of Total</h5>
          <h5 aria-hidden="true"></h5>
        </>
      );
    }
  }

  return (
    <div
      className={`${styles.container} ${showBenchmark ? '' : styles.collapse}`}
      data-testid="re-row-header">
      <HeaderHelmet {...helmet} />
      <h5 className="column_align_right">Affiliated</h5>
      <h5 className="column_align_right">Cocode</h5>
      <h5 className="column_align_right">Group</h5>
      <h5 className="column_align_right">Domicile</h5>
      {getHeader(helmet.subSectionHeaderType)}
      <h5 aria-hidden="true"></h5>
    </div>
  );
}
